import React from "react";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        paddingLeft: 10,
        paddingRight: 10,
        background: "linear-gradient(#041b23, #0c0f14)",
      }}
    >
      <div
        className="card"
        style={{
          background: "#05212b",
          borderRadius: "8px",
          border: "3px solid rgb(27, 179, 200)",
          color: "#fff",
        }}
      >
        <div className="card-body">
          <h1
            className="text-muted card-subtitle mb-2"
            style={{
              textAlign: "center",
              marginTop: 10,
              marginBottom: 12,
              padding: 20,
            }}
          >
            <span style={{ color: "#f63c3c" }}>404</span>{" "}
            <span style={{ color: "#ffffff" }}>- Page Not Found</span>
          </h1>
          <p
            className="card-text"
            style={{
              textAlign: "center",
              marginBottom: 36,
              marginTop: 27,
            }}
          >
            <span style={{ color: "#ffffff" }}>
              The page you are looking for may have been moved, deleted, or
              possibly never existed. Click{" "}
            </span>
            <Link to="/">
              <span
                style={{
                  textDecoration: "underline",
                  color: "rgb(27, 179, 200)",
                }}
              >
                here
              </span>
            </Link>
            <span style={{ color: "#ffffff" }}> to go back.</span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
